module.exports = __webpack_public_path__ + "static/img/icon-en-5.db2ed3ae.png";